import PropTypes from "prop-types";

import T from "./translations/Translations";

/**
 * Display a select list of available fiscal years
 * @param {{}} param0
 * @returns {JSX.Element}
 */
const SchoolYearSelect = ({ schoolYears, selectedSchoolYear, setSelectedQuarter, setSelectedSchoolYear }) => {
    /**
     * Set the selected school year
     * @name handleChange
     * @param {{}} e
     */
    const handleChange = (e) => {
        const selectedSchoolYearId = e.target.value === "" ? null : e.target.value;
        setSelectedSchoolYear(selectedSchoolYearId);
        setSelectedQuarter(null);
    };

    return (
        <div className="fiscal-year-dropdown">
            {T({ key: "Fiscal_Year_Instruction" })}
            <label className="in-row-label" htmlFor="fiscal-year-select">
                {T({ key: "Fiscal_Year" })}
                <select
                    aria-label="Select a fiscal year"
                    className="form-select"
                    id="fiscal-year-select"
                    name="fiscal-year"
                    onChange={handleChange}
                    value={selectedSchoolYear === null ? "" : selectedSchoolYear}
                >
                    <option value="">Select a fiscal year</option>
                    {schoolYears.map((schoolYear, index) => (
                        <option
                            key={`fiscal-year-option-${schoolYear.schoolYearId}-${index}`}
                            value={schoolYear.schoolYearId}
                        >
                            {schoolYear.schoolYearName}
                        </option>
                    ))}
                </select>
            </label>
        </div>
    );
};

SchoolYearSelect.propTypes = {
    schoolYears: PropTypes.instanceOf(Array).isRequired,
    selectedSchoolYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    setSelectedQuarter: PropTypes.func.isRequired,
    setSelectedSchoolYear: PropTypes.func.isRequired
};

SchoolYearSelect.defaultProps = {
    selectedSchoolYear: null
};

export default SchoolYearSelect;
